 export const nacionalidades = [{
         id: "A9199AAAAA",
         name: "ESPAÑA",
         code: 'ESP'
     }, {
         id: "A9401AAAAA",
         name: "AFGANISTAN",
         code: 'AFG'
     },
     {
         id: "A9399AAAAA",
         name: "AFRICA",
         code: 'AFR'
     },
     {
         id: "A9102AAAAA",
         name: "ALBANIA",
         code: 'ALB'
     },
     {
         id: "A9103AAAAA",
         name: "ALEMANIA",
         code: 'DEU'
     },
     {
         id: "A9299AAAAA",
         name: "AMERICA",
         code: 'AMR'
     },
     {
         id: "A9133AAAAA",
         name: "ANDORRA",
         code: 'AND'
     },
     {
         id: "A9301AAAAA",
         name: "ANGOLA",
         code: 'AGO'
     },
     {
         id: "A9255AAAAA",
         name: "ANTIGUA BARBUDA",
         code: 'ATG'
     },
     {
         id: "A9200AAAAA",
         name: "ANTILLAS NEERLANDESAS",
         code: 'ANT'
     },
     {
         id: "A9600AAAAA",
         name: "APATRIDA",
         code: 'APR'
     },
     {
         id: "A9403AAA1A",
         name: "ARABIA SAUDITA",
         code: 'SAU'

     },
     {
         id: "A9304AAAAA",
         name: "ARGELIA",
         code: 'DZA'
     },
     {
         id: "A9202AAAAA",
         name: "ARGENTINA",
         code: 'ARG'
     },
     {
         id: "A9142AAAAA",
         name: "ARMENIA",
         code: 'ARM'
     },
     {
         id: "A9257AAAAA",
         name: "ARUBA",
         code: 'ABW'
     },
     {
         id: "A9499AAAAA",
         name: "ASIA",
         code: 'ASI'

     },
     {
         id: "A9500AAAAA",
         name: "AUSTRALIA",
         code: 'AUS'
     },
     {
         id: "A9104AAAAA",
         name: "AUSTRIA",
         code: 'AUT'
     },
     {
         id: "A9143AAA2A",
         name: "AZERBAYAN",
         code: 'AZE'
     },
     {
         id: "A9203AAAAA",
         name: "BAHAMAS",
         code: 'BHS'
     },
     {
         id: "A9405AAAAA",
         name: "BAHREIN",
         code: 'BHR'
     },
     {
         id: "A9432AAAAA",
         name: "BANGLADESH",
         code: 'BGD'
     },
     {
         id: "A9205AAAAA",
         name: "BARBADOS",
         code: 'BRB'
     },
     {
         id: "A9105AAAAA",
         name: "BELGICA",
         code: 'BEL'
     },
     {
         id: "A9207AAAAA",
         name: "BELICE",
         code: 'BLZ'
     },
     {
         id: "A9407AAAAA",
         name: "BHUTAN",
         code: 'BTN'
     },
     {
         id: "A9144AAAAA",
         name: "BIELORRUSIA",
         code: 'BLR'
     },
     {
         id: "A9204AAAAA",
         name: "BOLIVIA",
         code: 'BOL'
     },
     {
         id: "A9156AAAAA",
         name: "BOSNIA Y HERZEGOVINA",
         code: 'BIH'
     },
     {
         id: "A9305AAAAA",
         name: "BOTSWANA",
         code: 'BWA'
     },
     {
         id: "A9206AAAAA",
         name: "BRASIL",
         code: 'BRA'
     },
     {
         id: "A9409AAAAA",
         name: "BRUNEI",
         code: 'BRN'
     },
     {
         id: "A9134AAAAA",
         name: "BULGARIA",
         code: 'BGR'
     },
     {
         id: "A9303AAAAA",
         name: "BURKINA FASO",
         code: 'BFA'
     },
     {
         id: "A9321AAAAA",
         name: "BURUNDI",
         code: 'BDI'
     },
     {
         id: "A9315AAAAA",
         name: "CABO VERDE",
         code: 'CPV'
     },
     {
         id: "A9402AAAAA",
         name: "CAMBOYA",
         code: 'KHM'
     },
     {
         id: "A9308AAAAA",
         name: "CAMERÚN",
         code: 'CMR'
     },
     {
         id: "A9208AAAAA",
         name: "CANADA",
         code: 'CAN'
     },
     {
         id: "A9372AAAAA",
         name: "CHAD",
         code: 'TCD'
     },
     {
         id: "A9210AAAAA",
         name: "CHILE",
         code: 'CHL'
     },
     {
         id: "A9406AAAAA",
         name: "CHINA",
         code: 'CHN',
     },
     {
         id: "A9107AAAAA",
         name: "CHIPRE",
         code: 'CYP'
     },
     {
         id: "A9212AAAAA",
         name: "COLOMBIA",
         code: 'COL'
     },
     {
         id: "A9311AAAAA",
         name: "COMORES",
         code: 'COM'
     },
     {
         id: "A9460AAAAA",
         name: "COREA DEL NORTE",
         code: 'PRK'
     },
     {
         id: "A9410AAAAA",
         name: "COREA DEL SUR",
         code: 'KOR'
     },
     {
         id: "A9314AAAAA",
         name: "COSTA DE MARFIL",
         code: 'CIV'
     },
     {
         id: "A9214AAAAA",
         name: "COSTA RICA",
         code: 'CRI'
     },
     {
         id: "A9140AAAAA",
         name: "CROACIA",
         code: 'HRV'
     },
     {
         id: "A9216AAAAA",
         name: "CUBA",
         code: 'CUB'
     },
     {
         id: "A9258AAAAA",
         name: "CURAZAO",
         code: 'CUW'
     },
     {
         id: "A9108AAAAA",
         name: "DINAMARCA",
         code: 'DNK'
     },
     {
         id: "A9317AAAAA",
         name: "DJIBOUTI",
         code: 'DJI'
     },
     {
         id: "A9217AAAAA",
         name: "DOMINICA",
         code: 'DMA'
     },
     {
         id: "A9222AAAAA",
         name: "ECUADOR",
         code: "ECU"
     },
     {
         id: "A9300AAAAA",
         name: "EGIPTO",
         code: "EGY"
     },
     {
         id: "A9429AAAAA",
         name: "EMIRATOS ÁRABES UNIDOS",
         code: "ARE"
     },
     {
         id: "A9384AAAAA",
         name: "ERITREA",
         code: "ERI"
     },
     {
         id: "A9158AAAAA",
         name: "ESLOVAQUIA",
         code: "SVK"
     },
     {
         id: "A9141AAAAA",
         name: "ESLOVENIA",
         code: "SVN"
     },
     {
         id: "A9525AAA1A",
         name: "ESTADOS FEDERADOS DE MICRONESIA",
         code: "FSM"
     },
     {
         id: "A9224AAA1A",
         name: "ESTADOS UNIDOS DE AMERICA",
         code: "USA"
     },
     {
         id: "A9137AAAAA",
         name: "ESTONIA",
         code: "EST"
     },
     {
         id: "A9318AAAAA",
         name: "ETIOPÍA",
         code: "ETH"
     },

     {
         id: "A9199AAAAA",
         name: "EUROPA",
         code: 'ESP'
     },
     {
         id: "A9396AAAAA",
         name: "FERNANDO POO",
         code: null
     },
     {
         id: "A9550AAAAA",
         name: "FIYI",
         code: "FJI"
     },
     {
         id: "A9411AAAAA",
         name: "FILIPINAS",
         code: "PHL"
     },
     {
         id: "A9110AAAAA",
         name: "FINLANDIA",
         code: "FIN"
     },
     {
         id: "A9111AAAAA",
         name: "FRANCIA",
         code: "FRA"
     },
     {
         id: "A9320AAAAA",
         name: "GABÓN",
         code: "GAB"
     },
     {
         id: "A9323AAAAA",
         name: "GAMBIA",
         code: "GMB"
     },
     {
         id: "A9145AAAAA",
         name: "GEORGIA",
         code: "GEO"
     },
     {
         id: "A9322AAAAA",
         name: "GHANA",
         code: "GHA"
     },
     {
         id: "A9113AAAAA",
         name: "GRECIA",
         code: "GRC"
     },
     {
         id: "A9228AAAAA",
         name: "GUATEMALA",
         code: "GTM"
     },
     {
         id: "A9325AAA3A",
         name: "GUINEA",
         code: "GIN"
     },
     {
         id: "A9328AAA1A",
         name: "GUINEA BISSAU",
         code: "GNB"
     },
     {
         id: "A9324AAAAA",
         name: "GUINEA ECUATORIAL",
         code: "GNQ"
     },
     {
         id: "A9225AAAAA",
         name: "GUYANA",
         code: "GUY"
     },
     {
         id: "A9230AAAAA",
         name: "HAITÍ",
         code: "HTI"
     },
     {
         id: "A9232AAAAA",
         name: "HONDURAS",
         code: "HND"
     },
     {
         id: "A9462AAAAA",
         name: "HONG KONG",
         code: "HKG"
     },
     {
         id: "A9114AAAAA",
         name: "HUNGRÍA",
         code: "HUN"
     },
     {
         id: "A9395AAAAA",
         name: "IFNI",
         code: null
     },
     {
         id: "A9412AAAAA",
         name: "INDIA",
         code: "IND"
     },
     {
         id: "A9414AAAAA",
         name: "INDONESIA",
         code: "IDN"
     },
     {
         id: "A9413AAAAA",
         name: "IRAK",
         code: "IRQ"
     },
     {
         id: "A9415AAAAA",
         name: "IRÁN",
         code: "IRN"
     },
     {
         id: "A9115AAAAA",
         name: "IRLANDA",
         code: "IRL"
     },
     {
         id: "A9116AAAAA",
         name: "ISLANDIA",
         code: "ISL"
     },
     {
         id: "A9518AAAAA",
         name: "ISLAS MARIANAS DEL NORTE",
         code: 'MNP'
     },
     {
         id: "A9520AAAAA",
         name: "ISLAS MARSHALL",
         code: 'MHL'
     },
     {
         id: "A9551AAA1A",
         name: "ISLAS SALOMÓN",
         code: "SLB"
     },
     {
         id: "A9417AAAAA",
         name: "ISRAEL",
         code: "ISR"
     },
     {
         id: "A9117AAAAA",
         name: "ITALIA",
         code: "ITA"
     },
     {
         id: "A9233AAAAA",
         name: "JAMAICA",
         code: "JAM"
     },
     {
         id: "A9416AAAAA",
         name: "JAPÓN",
         code: "JPN"
     },
     {
         id: "A9419AAAAA",
         name: "JORDANIA",
         code: "JOR"
     },
     {
         id: "A9465AAAAA",
         name: "KAZAJSTÁN",
         code: "KAZ"
     },
     {
         id: "A9336AAAAA",
         name: "KENIA",
         code: "KEN"
     },
     {
         id: "A9501AAAAA",
         name: "KIRIBATI",
         code: "KIR"
     },
     {
         id: "A9421AAAAA",
         name: "KUWAIT",
         code: "KWT"
     },
     {
         id: "A9418AAAAA",
         name: "LAOS",
         code: "LAO"
     },
     {
         id: "A9337AAAAA",
         name: "LESOTHO",
         code: "LSO"
     },
     {
         id: "A9138AAAAA",
         name: "LETONIA",
         code: "LVA"
     },
     {
         id: "A9423AAAAA",
         name: "LÍBANO",
         code: "LBN"
     },
     {
         id: "A9342AAAAA",
         name: "LIBERIA",
         code: "LBR"
     },
     {
         id: "A9344AAAAA",
         name: "LIBIA",
         code: "LBY"
     },
     {
         id: "A9118AAAAA",
         name: "LIECHTENSTEIN",
         code: "LIE"
     },
     {
         id: "A9139AAAAA",
         name: "LITUANIA",
         code: "LTU"
     },
     {
         id: "A9119AAAAA",
         name: "LUXEMBURGO",
         code: "LUX"
     },
     {
         id: "A9463AAAAA",
         name: "MACAO",
         code: null
     },
     {
         id: "A9159AAAAA",
         name: "MACEDONIA",
         code: "MKD"
     },
     {
         id: "A9354AAAAA",
         name: "MADAGASCAR",
         code: "MDG"
     },
     {
         id: "A9425AAAAA",
         name: "MALASIA",
         code: "MYS"
     },
     {
         id: "A9346AAAAA",
         name: "MALAWI",
         code: "MWI"
     },
     {
         id: "A9436AAAAA",
         name: "MALDIVAS",
         code: "MDV"
     },
     {
         id: "A9347AAAAA",
         name: "MALI",
         code: "MLI"
     },
     {
         id: "A9120AAAAA",
         name: "MALTA",
         code: "MLT"
     },
     {
         id: "A9348AAAAA",
         name: "MARRUECOS",
         code: "MAR"
     },
     {
         id: "A9349AAAAA",
         name: "MAURICIO",
         code: "MUS"
     },
     {
         id: "A9350AAAAA",
         name: "MAURITANIA",
         code: "MRT"
     },
     {
         id: "A9234AAA1A",
         name: "MEXICO",
         code: "MEX"
     },
     {
         id: "A9148AAAAA",
         name: "MOLDAVIA",
         code: "MDA"
     },
     {
         id: "A9121AAAAA",
         name: "MONACO",
         code: "MCO"
     },
     {
         id: "A9427AAAAA",
         name: "MONGOLIA",
         code: "MNG"
     },
     {
         id: "A9160AAAAA",
         name: "MONTENEGRO",
         code: "MNE"
     },
     {
         id: "A9351AAAAA",
         name: "MOZAMBIQUE",
         code: "MOZ"
     },
     {
         id: "A9400AAAAA",
         name: "MYANMAR",
         code: "MMR"
     },
     {
         id: "A9353AAAAA",
         name: "NAMIBIA",
         code: "NAM"
     },
     {
         id: "A9541AAAAA",
         name: "NAURU",
         code: "NRU"
     },
     {
         id: "A9420AAAAA",
         name: "NEPAL",
         code: "NPL"
     },
     {
         id: "A9236AAAAA",
         name: "NICARAGUA",
         code: "NIC"
     },
     {
         id: "A9360AAAAA",
         name: "NIGER",
         code: "NER"
     },
     {
         id: "A9352AAAAA",
         name: "NIGERIA",
         code: "NGA"
     },
     {
         id: "A9122AAAAA",
         name: "NORUEGA",
         code: "NOR"
     },
     {
         id: "A9540AAAAA",
         name: "NUEVAZELANDA",
         code: "NZL"
     },
     {
         id: "A9599AAAAA",
         name: "OCEANIA",
         code: null
     },
     {
         id: "A9444AAAAA",
         name: "OMAN",
         code: "OMN"
     },
     {
         id: "A9123AAA1A",
         name: "PAISESBAJOS",
         code: "NLD"
     },
     {
         id: "A9424AAA1A",
         name: "PAKISTAN",
         code: "PAK"
     },
     {
         id: "A9440AAAAA",
         name: "PALESTINA",
         code: null
     },
     {
         id: "A9238AAAAA",
         name: "PANAMA",
         code: "PAN"
     },
     {
         id: "A9542AAAAA",
         name: "PAPUA NUEVA GUINEA",
         code: "PNG"
     },
     {
         id: "A9240AAAAA",
         name: "PARAGUAY",
         code: "PRY"
     },
     {
         id: "A9242AAAAA",
         name: "PERÚ",
         code: "PER"
     },
     {
         id: "A9124AAAAA",
         name: "POLONIA",
         code: "POL"
     },
     {
         id: "A9125AAAAA",
         name: "PORTUGAL",
         code: "PRT"
     },
     {
         id: "A9244AAAAA",
         name: "PUERTO RICO",
         code: "PRI"
     },
     {
         id: "A9431AAAAA",
         name: "QATAR",
         code: "QAT"
     },
     {
         id: "A9112AAA1A",
         name: "REINO UNIDO",
         code: "GBR"
     },
     {
         id: "A9302AAA1A",
         name: "REPÚBLICA DE BENÍN",
         code: "BEN"
     },
     {
         id: "A9310AAA1A",
         name: "REPÚBLICA CENTROAFRICANA",
         code: "CAF"
     },
     {
         id: "A9157AAAAA",
         name: "REPÚBLICA CHECA",
         code: "CZE"
     },
     {
         id: "A9312AAA1A",
         name: "REPÚBLICA DEL CONGO",
         code: "COG"
     },
     {
         id: "A9380AAAAA",
         name: "REPÚBLICA DEMOCRÁTICA DEL CONGO",
         code: "COD"
     },
     {
         id: "A9218AAA1A",
         name: "REPÚBLICA DOMINICANA",
         code: "DOM"
     },
     {
         id: "A9229AAAAA",
         name: "REPÚBLICA DE GRANADA",
         code: "GRD"
     },
     {
         id: "A9466AAA1A",
         name: "REPÚBLICA DE KIRGUISTÁN",
         code: "KGZ"
     },
     {
         id: "A9369AAAAA",
         name: "REPÚBLICA DEL SUDÁN DEL SUR",
         code: "SSD"
     },
     {
         id: "A9397AAAAA",
         name: "RÍO MUNI",
         code: null
     },
     {
         id: "A9306AAAAA",
         name: "RUANDA",
         code: "RWA"
     },
     {
         id: "A9127AAAAA",
         name: "RUMANIA",
         code: "ROU"
     },
     {
         id: "A9149AAAAA",
         name: "RUSIA",
         code: "RUS"
     },
     {
         id: "A9398AAAAA",
         name: "SAHARA",
         code: "ESH"
     },
     {
         id: "A9256AAA1A",
         name: "SAINT KITTS Y NEVIS",
         code: "KNA"
     },
     {
         id: "A9220AAAAA",
         name: "EL SALVADOR",
         code: "SLV"
     },
     {
         id: "A9552AAAAA",
         name: "SAMOA OCCIDENTAL",
         code: "WSM"
     },
     {
         id: "A9135AAAAA",
         name: "SAN MARINO",
         code: "SMR"
     },
     {
         id: "A9259AAAAA",
         name: "SAN MARTÍN",
         code: "MAF"
     },
     {
         id: "A9254AAA1A",
         name: "SAN VICENTE Y LAS GRANADINAS",
         code: "VCT"
     },
     {
         id: "A9253AAAAA",
         name: "SANTA LUCÍA",
         code: "LCA"
     },
     {
         id: "A9136AAA2A",
         name: "CIUDAD DEL VATICANO",
         code: "VAT"
     },
     {
         id: "A9361AAAAA",
         name: "SANTO TOMÉ Y PRÍNCIPE",
         code: "STP"
     },
     {
         id: "A9362AAAAA",
         name: "SENEGAL",
         code: "SEN"
     },
     {
         id: "A9155AAAAA",
         name: "SERBIA",
         code: "SRB"
     },
     {
         id: "A9363AAAAA",
         name: "SEYCHELLES",
         code: "SYC"
     },
     {
         id: "A9364AAAAA",
         name: "SIERRA LEONA",
         code: "SLE"
     },
     {
         id: "A9426AAAAA",
         name: "SINGAPUR",
         code: "SGP"
     },
     {
         id: "A9433AAAAA",
         name: "SIRIA",
         code: "SYR"
     },
     {
         id: "A9365AAAAA",
         name: "SOMALIA",
         code: "SOM"
     },
     {
         id: "A9404AAAAA",
         name: "SRI LANKA",
         code: "LKA"
     },
     {
         id: "A9367AAAAA",
         name: "SUDÁFRICA",
         code: "ZAF"
     },
     {
         id: "A9368AAAAA",
         name: "SUDÁN",
         code: "SDN"
     },
     {
         id: "A9369AAA1A",
         name: "SUDÁN DEL SUR",
         code: "SSD"
     },
     {
         id: "A9128AAAAA",
         name: "SUECIA",
         code: "SWE"
     },
     {
         id: "A9129AAAAA",
         name: "SUIZA",
         code: "CHE"
     },
     {
         id: "A9250AAAAA",
         name: "SURINAM",
         code: "SUR"
     },
     {
         id: "A9371AAAAA",
         name: "ESWATINI",
         code: "SWZ"
     },
     {
         id: "A9469AAAAA",
         name: "TAYIKISTÁN",
         code: "TJK"
     },
     {
         id: "A9428AAA1A",
         name: "TAILANDIA",
         code: "THA"
     },
     {
         id: "A9408AAA3A",
         name: "TAIWÁN",
         code: "TWN"
     },
     {
         id: "A9370AAAAA",
         name: "TANZANIA",
         code: "TZA"
     },
     {
         id: "A9464AAAAA",
         name: "TIMOR ORIENTAL",
         code: "TLS"
     },
     {
         id: "A9374AAAAA",
         name: "TOGO",
         code: "TGO"
     },
     {
         id: "A9554AAAAA",
         name: "TONGA",
         code: "TON"
     },
     {
         id: "A9245AAAAA",
         name: "TRINIDAD Y TOBAGO",
         code: "TTO"
     },
     {
         id: "A9378AAAAA",
         name: "TÚNEZ",
         code: "TUN"
     },
     {
         id: "A9467AAA1A",
         name: "TURKMENISTÁN",
         code: "TKM"
     },
     {
         id: "A9130AAAAA",
         name: "TURQUÍA",
         code: "TUR"
     },
     {
         id: "A9560AAAAA",
         name: "TUVALU",
         code: "TUV"
     },
     {
         id: "A9152AAAAA",
         name: "UCRANIA",
         code: "UKR"
     },
     {
         id: "A9358AAAAA",
         name: "UGANDA",
         code: "UGA"
     },
     {
         id: "A9190AAA1A",
         name: "UNIÓN EUROPEA",
         code: "EU"
     },
     {
         id: "A9246AAAAA",
         name: "URUGUAY",
         code: "URY"
     },
     {
         id: "A9468AAAAA",
         name: "UZBEKISTÁN",
         code: "UZB"
     },
     {
         id: "A9565AAAAA",
         name: "VANUATU",
         code: "VUT"
     },
     {
         id: "A9248AAAAA",
         name: "VENEZUELA",
         code: "VEN"
     },
     {
         id: "A9430AAAAA",
         name: "VIETNAM",
         code: "VNM"
     },
     {
         id: "A9434AAAAA",
         name: "YEMEN",
         code: "YEM"
     },
     {
         id: "A9382AAAAA",
         name: "ZAMBIA",
         code: "ZMB"
     }
 ]